import { getHandler, patchHandler, postHandler } from 'src/utils/fetchHandler';
import { getPendingImportJobUpdate, getPendingImportJobCreate } from './importJob.selector';

export const CLEAR_IMPORT_JOBS = 'CLEAR_IMPORT_JOBS/IMPORT_JOB/@WISELY/WEB';
export const CLEAR_IMPORT_JOB_UPDATE_ERRORS =
	'CLEAR_IMPORT_JOB_UPDATE_ERRORS/IMPORT_JOB/@WISELY/WEB';
export const CLEAR_IMPORT_JOB_CREATE_ERRORS =
	'CLEAR_IMPORT_JOB_CREATE_ERRORS/IMPORT_JOB/@WISELY/WEB';
export const GET_IMPORT_JOB = 'GET_IMPORT_JOB/IMPORT_JOB/@WISELY/WEB';
export const GET_IMPORT_JOBS = 'GET_IMPORT_JOBS/IMPORT_JOB/@WISELY/WEB';
export const FETCH_IMPORT_JOB_FAILED = 'FETCH_IMPORT_JOB_FAILED/IMPORT_JOB/@WISELY/WEB';
export const FETCH_IMPORT_JOB_SUCCEEDED = 'FETCH_IMPORT_JOB_SUCCEEDED/IMPORT_JOB/@WISELY/WEB';
export const FETCH_IMPORT_JOBS_FAILED = 'FETCH_IMPORT_JOBS_FAILED/IMPORT_JOB/@WISELY/WEB';
export const FETCH_IMPORT_JOBS_SUCCEEDED = 'FETCH_IMPORT_JOBS_SUCCEEDED/IMPORT_JOB/@WISELY/WEB';
export const UPDATE_IMPORT_JOB = 'UPDATE_IMPORT_JOB/IMPORT_JOB/@WISELY/WEB';
export const UPDATE_IMPORT_JOB_FAILED = 'UPDATE_IMPORT_JOB_FAILED/IMPORT_JOB/@WISELY/WEB';
export const UPDATE_IMPORT_JOB_SUCCEEDED = 'UPDATE_IMPORT_JOB_SUCCEEDED/IMPORT_JOB/@WISELY/WEB';
export const CREATE_IMPORT_JOB = 'CREATE_IMPORT_JOB/IMPORT_JOB/@WISELY/WEB';
export const CREATE_IMPORT_JOB_FAILED = 'CREATE_IMPORT_JOB_FAILED/IMPORT_JOB/@WISELY/WEB';
export const CREATE_IMPORT_JOB_SUCCEEDED = 'CREATE_IMPORT_JOB_SUCCEEDED/IMPORT_JOB/@WISELY/WEB';

export const clearImportJobs = () => ({
	type: CLEAR_IMPORT_JOBS,
});

export const clearImportJobUpdateErrors = () => ({
	type: CLEAR_IMPORT_JOB_UPDATE_ERRORS,
});

export const clearImportJobCreateErrors = () => ({
	type: CLEAR_IMPORT_JOB_CREATE_ERRORS,
});

export const getImportJob = () => ({
	type: GET_IMPORT_JOB,
});

export const getImportJobs = () => ({
	type: GET_IMPORT_JOBS,
});

export const fetchImportJobFailed = payload => ({
	type: FETCH_IMPORT_JOB_FAILED,
	payload,
});

export const fetchImportJobSucceeded = payload => ({
	type: FETCH_IMPORT_JOB_SUCCEEDED,
	payload,
});

export const fetchImportJobsFailed = payload => ({
	type: FETCH_IMPORT_JOBS_FAILED,
	payload,
});

export const fetchImportJobsSucceeded = payload => ({
	type: FETCH_IMPORT_JOBS_SUCCEEDED,
	payload,
});

export const fetchImportJob = (id, params) => {
	return dispatch => {
		dispatch(getImportJob());
		const path = `v2/import_jobs/${id}`;

		return getHandler(path, params)
			.then(json => dispatch(fetchImportJobSucceeded(json)))
			.catch(error => {
				console.error('fetchImportJob error', error);
				dispatch(fetchImportJobFailed());
			});
	};
};

export const fetchImportJobs = params => {
	return async dispatch => {
		dispatch(getImportJobs());
		const path = 'v2/import_jobs';

		// by default, get most recently started first
		params = {
			$sort: { start: -1 },
			...params,
		};

		return getHandler(path, params)
			.then(json => dispatch(fetchImportJobsSucceeded(json)))
			.catch(error => {
				console.error('fetchImportJobs error', error);
				dispatch(fetchImportJobsFailed(error));
			});
	};
};

export const updateImportJob = () => ({
	type: UPDATE_IMPORT_JOB,
});

export const requestUpdateImportJobFailed = payload => ({
	type: UPDATE_IMPORT_JOB_FAILED,
	payload,
});

export const requestUpdateImportJobSucceeded = payload => ({
	type: UPDATE_IMPORT_JOB_SUCCEEDED,
	payload,
});

export const requestUpdateImportJob = (id, body) => {
	return async (dispatch, getState) => {
		if (getPendingImportJobUpdate(getState())) {
			return;
		}
		dispatch(updateImportJob());
		const path = `v2/import_jobs/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateImportJobSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateImportJob error', error);
				dispatch(requestUpdateImportJobFailed(error));
			});
	};
};

export const createImportJob = () => ({
	type: CREATE_IMPORT_JOB,
});

export const requestCreateImportJobFailed = payload => ({
	type: CREATE_IMPORT_JOB_FAILED,
	payload,
});

export const requestCreateImportJobSucceeded = payload => ({
	type: CREATE_IMPORT_JOB_SUCCEEDED,
	payload,
});

export const requestCreateImportJob = body => {
	return async (dispatch, getState) => {
		if (getPendingImportJobCreate(getState())) {
			return;
		}
		dispatch(createImportJob());
		const path = `v2/import_jobs`;

		return postHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestCreateImportJobSucceeded(json)))
			.catch(error => {
				console.error('requestCreateImportJob error', error);
				dispatch(requestCreateImportJobFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/importJobs/importJob.action.js